// extracted by mini-css-extract-plugin
export default {"container":"ResponsiveContainer_container__Zc13t"};